import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import FeedbackPopup from '../FeedbackPopup';
import { OverageBanner } from './OverageBanner';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const location = useLocation();
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  
  const getPageTitle = (pathname: string): string => {
    switch (pathname) {
      case '/':
        return 'Dashboard';
      case '/pipeline':
        return 'Pipeline';
      case '/ai-agents/lead-gen':
        return 'Lead Gen Agent';
      case '/ai-agents/call-agent':
        return 'Call Agent';
      case '/ai-agents/whatsapp-agent':
        return 'WhatsApp Agent';
      case '/ai-agents/email-agent':
        return 'Email Agent';
      case '/ai-agents/linkedin-agent':
        return 'LinkedIn Agent';
      case '/leads/outbound':
        return 'Outbound Leads';
      case '/leads/inbound':
        return 'Inbound Leads';
      case '/pre-qualified-leads':
        return 'Lead Gen Agent | Pre-Qualified Leads';
      case '/lead-requests':
        return 'Lead Gen Agent | Lead Requests';
      case '/sales-coach':
        return 'Sales Coach';
      case '/meetings':
        return 'Meetings';
      case '/settings':
        return 'Settings';
      case '/campaigns':
        return 'Campaigns';
      case '/campaigns/call':
        return 'Campaigns | Call Campaign';
      case '/campaigns/whatsapp':
        return 'Campaigns | WhatsApp Campaign';
      case '/campaigns/email':
        return 'Campaigns | Email Campaign';
      case '/campaigns/linkedin':
        return 'Campaigns | LinkedIn Campaign';
      case '/campaigns/omni-channel':
        return 'Campaigns | Omni-Channel Campaign';
      case '/campaigns/inbound':
        return 'Campaigns | Inbound Campaign';
      default:
        if (pathname.startsWith('/pipeline/')) return 'Pipeline';
        return 'Dashboard';
    }
  };

  // Determine if feedback popup should be visible based on current route
  const shouldShowFeedback = [
    '/ai-agents/lead-gen',
    '/ai-agents/call-agent',
    '/ai-agents/whatsapp-agent',
    '/ai-agents/email-agent',
    '/ai-agents/linkedin-agent'
  ].includes(location.pathname);

  return (
    <div className="h-screen flex bg-gray-50">
      <Sidebar 
        isExpanded={isSidebarExpanded}
        setIsExpanded={setIsSidebarExpanded}
      />
      <div 
        className={`flex-1 flex flex-col overflow-hidden transition-all duration-300 ease-in-out ${
          isSidebarExpanded ? 'ml-64' : 'ml-16'
        }`}
      >
        <Topbar pageTitle={getPageTitle(location.pathname)} />
        <OverageBanner />
        <main className={`flex-1 ${location.pathname === '/sales-coach' || location.pathname === '/settings' ? 'overflow-hidden' : 'overflow-y-auto p-6'}`}>
          {children}
        </main>
      </div>
      
      {/* Feedback Popup - Only show on agent pages */}
      <FeedbackPopup isVisible={shouldShowFeedback} />
    </div>
  );
};

export default MainLayout;